import { cx } from '@runnerboy/ui';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { NightRoadScene } from './art';

/**
 * Runner Boy's signature asset: the night-road scene above the pledge. Art and copy are stacked (never overlapping)
 * so the message stays legible outdoors on any screen.
 */
export function SignatureHero({ compact, linked = true, className }: { compact?: boolean; linked?: boolean; className?: string }) {
  const { t } = useTranslation();
  const body = (
    <>
      <div className={cx('relative overflow-hidden', compact ? 'h-[132px]' : 'h-[178px]')}>
        <NightRoadScene className="absolute inset-0 h-full w-full" />
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-night-900 to-transparent" />
      </div>
      <div className={cx('relative px-5', compact ? 'pb-4' : 'pb-5')}>
        <div className="rb-eyebrow text-[10px] text-marigold-200/80">{t('safety.kicker', 'Runner Boy road-safety pledge')}</div>
        <div className={cx('rb-display mt-1.5 font-extrabold leading-[0.95] text-marigold-500', compact ? 'text-[28px]' : 'text-[34px]')}>{t('safety.line1', 'DON’T DRINK & DRIVE.')}</div>
        <div className={cx('rb-display mt-1 font-bold leading-[1.05] text-white', compact ? 'text-[17px]' : 'text-[20px]')}>{t('safety.line2', 'ORDER FROM YOUR PLACE. BE SAFE.')}</div>
        {linked && !compact && (
          <span className="rb-glass mt-4 inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-[13px] font-semibold text-white">
            {t('safety.why', 'Why it matters')} <ArrowRight className="h-4 w-4 text-marigold-500" aria-hidden />
          </span>
        )}
      </div>
    </>
  );
  const shell = cx('block overflow-hidden rounded-[28px] bg-night-900 shadow-[var(--shadow-float)] ring-1 ring-white/[0.06]', className);
  return linked ? (
    <Link to="/road-safety" className={cx('rb-press', shell)} aria-label={t('safety.title', 'Road safety')}>
      {body}
    </Link>
  ) : (
    <div className={shell}>{body}</div>
  );
}
